export default "__VITE_ASSET__BcdISl5l__"